import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-mental-health-line text-white text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-white whitespace-nowrap">
                健康认知指南
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              提供基于医学与心理学的权威性健康科普，帮助每一位成年人建立理性健康的自我认知。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm">内容分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-white transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm">更多分类</h4>
            <ul className="space-y-2">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-white transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-300 hover:text-white transition-colors duration-200 whitespace-nowrap"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4 text-sm">免责声明</h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              本站内容仅供健康科普参考，不构成医疗建议。如有健康问题，请咨询专业医疗机构。
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-800/30 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} 健康认知指南. 保留所有权利.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <Link to="/about" className="hover:text-white transition-colors duration-200 whitespace-nowrap">
              关于我们
            </Link>
            <span>|</span>
            <span className="whitespace-nowrap">内容仅供参考</span>
          </div>
        </div>
      </div>
    </footer>
  );
}